import styled from 'styled-components';
import { colours } from '@cambridgeassessment/cambridge-ui';

const PageWrapper = styled.div`
  padding: 0 0 32px;
  background: ${colours.white};
`;

export default PageWrapper;
